var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSubmission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146 353c4 0 9 2 12 4l50 36 14 10 278 201 342-247c9-7 22-4 29 5 3 3 4 8 4 12v418c0 46-37 83-83 83H208c-46 0-83-37-83-83V374c0-11 9-21 21-21zm604-186c23 0 42 18 42 41v134L500 553 208 342V208c0-23 19-41 42-41h500zM521 375H396c-12 0-21 9-21 21 0 10 7 19 17 20l4 1h125c11 0 21-10 21-21 0-12-10-21-21-21zm125-83H396c-12 0-21 9-21 20s7 19 17 21h254c11 0 21-9 21-21 0-11-10-20-21-20z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSubmission);
export default __webpack_public_path__ + "static/media/ic_submission.5c169f52adf00b837c55f136d093edb3.svg";
export { ForwardRef as ReactComponent };